import tutorialVideo from "../assets/videos/tutorial.mp4";

export default function Tutorial() {
    return (
        <div className="flex items-center flex-col gap-8 w-11/12 max-w-4xl">
            <p>Seja bem vindo ao Buscador de Videos do <b>Robozinho do XVIDEOS</b>. Aqui você vai encontrar com facilidade todos os vídeos e/ou canais premium do XVIDEOS. Assista ao vídeo abaixo e veja como é fácil encontrar os vídeos/canais que está buscando!</p>

            <video controls className="aspect-video w-full bg-black" src={tutorialVideo}></video>

            <a className="bg-xv-red hover:brightness-90 px-8 py-4 font-medium rounded-md" href="/search">Faça sua busca!</a>
        </div>
    )
}
